import { copyright } from './copyright.js';
import { navBarScrollHandler } from './navbar.js';
import AOS from 'aos';

copyright();
navBarScrollHandler();
AOS.init();
